module.exports = __webpack_public_path__ + "a6b764989ad7fd6c3d96a28af6d29a69.png";